import React from 'react'
import PropTypes from 'prop-types'

function LoadingScreen(props: any) {
    const item = props.item;
    return (
        <div className='screenLoading'>
            <div className='divloader'>
                <div className='spinner'></div>
            </div>
        </div>
    )
}

export default LoadingScreen

